import React from "react"
import NavBar from "./Pages/Home/Navbar";
import MySkills from "./Pages/Home/MySkills";
import {Route,Routes} from "react-router-dom"
import Home from "./Pages/Home/HomeScreen";
import "boxicons/css/boxicons.min.css";

import "./App.css"
function App() {
  return (
    <div className="App">
        <NavBar/>
        <div>
         <Routes>
          <Route exact path="/" element={<Home/>} />          
          <Route path="*"  element={<div>404 not found</div>}/>
          </Routes> 
        </div>
    </div>
  );
}

export default App;
